module.exports = __webpack_public_path__ + "static/media/youtube.18537ce0.svg";